import PropTypes from 'prop-types';
import React from 'react';

import { TagEnv } from './styles';

const Environment = ({ env }) => (
  <>
    {env !== 'production' && (
      <TagEnv color={env === 'development' ? 'blue' : 'green'}>{env}</TagEnv>
    )}
  </>
);

Environment.propTypes = {
  env: PropTypes.string,
};

Environment.defaultProps = {
  env: 'development',
};

export default Environment;
